import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore";
import {getStorage} from "firebase/storage";
import {getAuth, GoogleAuthProvider} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDzwuOp9dOCJOAa_EnSe7eWJ61dQKY0pLc",
  authDomain: "ckmportfolio.firebaseapp.com",
  projectId: "ckmportfolio",
  storageBucket: "ckmportfolio.appspot.com",
  messagingSenderId: "413368201334",
  appId: "1:413368201334:web:9c92da09a791a6381b6f57",
  measurementId: "G-TB8K5JL4PM"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleAuthProvider = new GoogleAuthProvider();